<template>
  <QPage>
    <AuthTitleBtn
      :title="$t('ETAB.PAGES.STARTUP.WRONG_APP.@TITLE')"
      :first-btn-label="$t('ETAB.PAGES.STARTUP.WRONG_APP.@GO_CANDIDATE')"
      :second-btn-label="$t('ETAB.PAGES.STARTUP.WRONG_APP.@GO_TO_SIGNUP')"
      :first-btn-action="goToCandidate"
      :second-btn-action="goToSignup"
    />
  </QPage>
</template>

<script>
  import { StoresService } from "@core/plugins/mobile";
  import { WWW_JOBS_URL } from "@core/constants";
  import { JavascriptHelpers } from "@core/helpers";
  import AuthTitleBtn from "@etab/components/auth/AuthTitleBtn.component.vue";
  import { ETAB_ROUTES } from "@etab/config";
  import { TrackingManager } from "@core/managers/tracking.manager";

  export default {
    components: {
      AuthTitleBtn,
    },
    methods: {
      goToCandidate() {
        TrackingManager.addEvent({
          event: "landing_dispatch",
          cta: "step2_is_candidate",
        });
        const couldOpenStore = StoresService.openCandidateRelevantStore();
        if (!couldOpenStore) {
          JavascriptHelpers.openUrl(WWW_JOBS_URL, "_blank");
        }
      },
      goToSignup() {
        TrackingManager.addEvent({
          event: "landing_dispatch",
          cta: "step2_is_etab",
        });
        this.$router.push({ name: ETAB_ROUTES.auth.signup.name });
      },
    },
  };
</script>
